export default import.meta.ROLLDOWN_FILE_URL_sJIeM7hgG3OfUlyD3$43gw